<template>
  <div class='notFound'>
    <img :src="notFoundSrc" alt="">
  </div>
</template>
<script>
export default {
  name: "notFound",
  data(){
    return {
      notFoundSrc: require('../../assets/images/404.png')
    }
  },
}
</script>
<style lang="scss" scoped>
.notFound{
  display:-webkit-box;
	display:-ms-flexbox;
	display:flex-box;
	display:flex;
	-webkit-box-align:center;
	-ms-flex-align:center;
	align-items:center;
	-webkit-box-pack:center;
	-ms-flex-pack:center;
	justify-content:center;
	text-align:center;
  height: calc(100% - 41px);
  img{
    width: 750px;
    height: 269px;
  }
}
</style>